import { Translations } from '@scorenco/components';

export const T_KEYS = {
  ...Translations.T_KEYS,

  // COMMON
  LIVE_MATCH: 'LIVE_MATCH',
  LAST_MATCH: 'LAST_MATCH',
  NEXT_MATCHS: 'NEXT_MATCHS',
  OTHER_ROUND_EVENTS: 'OTHER_ROUND_EVENTS',
  DEFAULT_HTML_TITLE: 'DEFAULT_HTML_TITLE',

  // TOURNAMENT

  TOURNAMENTS_FINALES_LABEL: 'TOURNAMENTS_FINALES_LABEL',
  TOURNAMENTS_SEMI_FINALS_LABEL: 'TOURNAMENTS_SEMI_FINALS_LABEL',
  TOURNAMENTS_QUARTER_FINALS_LABEL: 'TOURNAMENTS_QUARTER_FINALS_LABEL',
  TOURNAMENTS_ROUND_OF_SIXTEEN_LABEL: 'TOURNAMENTS_ROUND_OF_SIXTEEN_LABEL',

  TOURNAMENTS_ELIMINATION_PHASE_NAME: 'TOURNAMENTS_ELIMINATION_PHASE_NAME',
};

export type T_KEYS = typeof T_KEYS;
